import { useQueryClient } from '@tanstack/react-query'
import { useContext } from 'react'
import router from 'next/router'

import { AuthorizationContext } from 'src/shared/context'

import { useMutationHook } from './mutationHook'
import { apiPost } from '../config'
import { API_ROUTES } from '../routes'

interface IRegisterAuthorParams {
  firstName: string
  lastName: string
  middleName: string
}

async function fetchRegisterAuthor(path: string, body: IRegisterAuthorParams, token: string | null) {
  const headers = { Authorization: `Bearer ${token}` }

  try {
    const { data } = await apiPost<IRegisterAuthorParams, void>({ path, body, headers })

    return data
  } catch (error: any) {
    if (error.response?.status === 401) {
      throw new Error('Unauthorized')
    }
    throw error
  }
}

export const useRegisterAuthor = () => {
  const queryClient = useQueryClient()
  const { token, setToken } = useContext(AuthorizationContext)
  const path = API_ROUTES.AUTHOR_REGISTER

  const mutationFn = (url: string, body: IRegisterAuthorParams) => fetchRegisterAuthor(url, body, token)

  return useMutationHook({
    path,
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_ROUTES.AUTHOR_GET],
      })
    },
    onError: (error: Error) => {
      if (error.message === 'Unauthorized') {
        setToken('')
        router.push('/')
      }
    },
  })
}
